import { ComingSoonPage } from "../components/ComingSoonPage";

export function SettingsPage() {
	return (
		<ComingSoonPage
			title="Settings"
			subtitle="Team, billing, API keys, methodology, audit log."
			arrivesIn="v1.0"
			detail={[
				"Manage manufacturer users (admin / analyst / viewer).",
				"Billing managed via Stripe; portal launches in-app.",
				"API key management is Pro-tier only.",
				"Audit log shows every dashboard read for your manufacturer for the last 13 months.",
			]}
		/>
	);
}
